export function Empty({ ...rest }) {
  return (
    <svg
      width="64"
      height="40"
      viewBox="0 0 64 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_342_7703)">
        <path
          d="M32 39.7032C49.6731 39.7032 64 36.5925 64 32.7552C64 28.9179 49.6731 25.8071 32 25.8071C14.3269 25.8071 0 28.9179 0 32.7552C0 36.5925 14.3269 39.7032 32 39.7032Z"
          fill="#E4E4E3"
        />
        <path
          d="M55 13.6653L44.854 2.24866C44.367 1.47048 43.656 1 42.907 1H21.093C20.344 1 19.633 1.47048 19.146 2.24767L9 13.6663V22.8367H55V13.6653Z"
          stroke="#C9C9C6"
        />
        <path
          d="M41.613 16.8126C41.613 15.2195 42.607 13.9043 43.84 13.9033H55V31.9057C55 34.0129 53.68 35.74 52.05 35.74H11.95C10.32 35.74 9 34.0119 9 31.9057V13.9033H20.16C21.393 13.9033 22.387 15.2165 22.387 16.8096V16.8314C22.387 18.4245 23.392 19.7109 24.624 19.7109H39.376C40.608 19.7109 41.613 18.4126 41.613 16.8195V16.8126V16.8126Z"
          fill="#FAFAFA"
          stroke="#C9C9C6"
        />
      </g>
      <defs>
        <clipPath id="clip0_342_7703">
          <rect width="64" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Empty;
